var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcLikedAvatarDesktop(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icLikedAvatarDesktop") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 26,
    cy: 26,
    r: 26
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-12.5%",
    y: "-10.6%",
    width: "125.0%",
    height: "125.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.3 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18.720874,14.9582764 C20.4549824,14.9582764 22.2638262,16.1318254 23.6067029,17.5206353 L26.0136853,20.0140604 C26.1413143,20.1474084 26.3188584,20.2229605 26.5045915,20.2229605 C26.6903245,20.2229605 26.8678686,20.1474084 26.9954976,20.0140604 L29.6115479,16.998291 C33.0648926,13.8137695 37.2277571,14.7430189 39.9134766,17.5206353 C42.5991622,20.2982483 41.6949822,24.8001781 39.0092965,27.5777944 C34.8382747,31.8915409 30.6702926,36.2111631 26.4993045,40.5248429 L13.989347,27.5673783 C11.3056208,24.7864903 10.6357895,19.7758439 13.3215088,16.998291 C14.6643516,15.6094845 16.9867656,14.9582764 18.720874,14.9582764 Z",
    id: "path-4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "RHP-Search--Desktop-v2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icLikedAvatarDesktop",
    transform: "translate(4.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask-Copy-4"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-3)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-5",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-4"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask-Copy-3",
    fill: "#7EC34D",
    fillRule: "nonzero",
    xlinkHref: "#path-4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLikedAvatarDesktop);
export default __webpack_public_path__ + "static/media/icLikedAvatarDesktop.3c89cb35cd1cca72860c97c11997a16c.svg";
export { ForwardRef as ReactComponent };